import React from 'react';
import { connect, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Table } from 'app-components';
import { useModal } from '@hooks/useModal';
import { ROOT_STATE } from '@store/store.types';
import {  resultColumns } from './StateBasedTableConfig';
import { StateSubsidyModel } from './types/apiResponse';

interface IHouseholdProps{
    data: any,
    screenType: string,
    handleShowMember?: any,
    stateSubsidyModel?: StateSubsidyModel | string,
    stateSubsidyApplicable?: boolean,
}
const HouseholdMembersTable = (householdTableProps: IHouseholdProps) => {
    const { data, screenType, handleShowMember, stateSubsidyModel, stateSubsidyApplicable } = householdTableProps;
    const stateCode = useSelector((state: ROOT_STATE) => state.common.environment.stateCode);
    const { openModal } = useModal();

    const NoResultsFound = () => {
        return (
            <div>
                <FormattedMessage id='archive.hh.no_results_found' />
            </div>
        );
    };

    return (
        <div>
            { data && data.length > 0 ? <Table data={data} columns={resultColumns(screenType, stateSubsidyModel, stateSubsidyApplicable, stateCode, openModal)} hasBorders onSelectRow={ handleShowMember } /> : <NoResultsFound /> } 
        </div>
    );
};

export default connect(null, null)(HouseholdMembersTable);